import { GetterTree } from 'vuex'
import { NotificationType } from './types'
import { RootState } from '../types'
export const getters: GetterTree<NotificationType, RootState> = {
  newNotifications: state => state.newNotifications,
  notificationsUnread: state => {
    //se suman las notificaciones totales no leidas y las nuevas notificaciones por subscripcion
    // const oldNotifications = state.unreadNotificationsCount
    // const newNotifications = state.newNotifications.Filter(item => !item.read)
    //   .length
    // return newNotifications + oldNotifications
    return state.unreadNotificationsCount
  }
}
